// removed by extract-text-webpack-plugin
module.exports = {"chart":"DonutChart__chart___3Oqve","isLargeFont":"DonutChart__isLargeFont___26pcP","content":"DonutChart__content___XELOb","isCenter":"DonutChart__isCenter___2rcBr","donutchartTrack":"DonutChart__donutchartTrack___1Wq4c","donutchartIndicator":"DonutChart__donutchartIndicator___2Gnju","donutchart":"DonutChart__donutchart___1gZCm","donutchartText":"DonutChart__donutchartText___2R2k-","donutchartTextVal":"DonutChart__donutchartTextVal___1xDXT","donutchartTextPercent":"DonutChart__donutchartTextPercent___1RvW6","donutchartTextLabel":"DonutChart__donutchartTextLabel___37Cls"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/DonutChart/DonutChart.scss
// module id = 537
// module chunks = 0